import api from "./api";

export const ListarPromocoes = async () => {
  try {
    const res = await api.get(`/promocoes`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarPromocoes = async (data) => {
  try {
    const promo = await api.post(`/promocoes`, data);
    return promo.data;
  } catch (error) {
    throw error;
  }
};

export const EditarPromocao = async (data, id) => {
  try {
    const promocao = await api.put(`/promocoes/${id}`, data);
    return promocao.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarPromocao = async (id) => {
  try {
    const promocao = await api.delete(`/promocoes/${id}`);
    return promocao.data;
  } catch (error) {
    throw error;
  }
};
